import { Pipe, PipeTransform } from '@angular/core';
import { Status } from './itineray.model';

@Pipe({
  name: 'itineraryStatusLabel'
})
export class ItineraryStatusLabelPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const status: Status = value;
    switch (status) {
      case Status.TODO: return "Da Iniziare";
      case Status.IN_PROGRESS: return "In Lavorazione";
      case Status.PROCESSING: return "In Elaborazione";
      case Status.IN_REVIEW: return "In Revisione";
      case Status.DONE: return "Consegnato";
    }
  }

}
